// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"flag_wrapper__1q1n3","small":"flag_small__1Xw0T","medium":"flag_medium__1ed81","primary":"flag_primary__34_Wn","active":"flag_active__3ofd4"};